import type { EmployeeTermsConfig } from '#types/config/components/dialog/employeeTerms'
import type { RecursivePartial } from '#types/utils'

export default {
  dontAcceptButtonVariant: 'secondary',
} satisfies RecursivePartial<EmployeeTermsConfig>
